<template>
    <div>
        <div class="card dashcard mb-0">

            <div class="card-body">

                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load(1)" />
                    </div>

                    <div class="col col-12 col-md-2" v-if="filtros.status == 'N' || filtros.status == 'P'">
                        <az-input
                            icon="fa fa-calendar-o"
                            placeholder="Data Criação"
                            :edicao="false"
                            optionsData="id"
                            value="Data Criação" />
                    </div>

                    <div class="col col-12 col-md-2" v-else>
                        <az-input
                            icon="fa fa-calendar-o"
                            type="select"
                            placeholder="Data Criação"
                            :optionsList="[
                                { id: 'dt_coleta', search: 'Data Coleta' }, 
                                { id: 'dt_prazo', search: 'Data Prazo Descarte' }, 
                                { id: 'dt_leitura', search: 'Data da Leitura' }, 
                            ]"
                            optionsData="id"
                            v-model="filtros.tipo_data" />
                    </div>

                    <div class="col col-12 col-md-4">
                        <az-input   
                            type="select"
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            icon="fa fa-building-o fa-fw"
                            placeholder="Unidades..."
                            v-model="filtros.id_unidade_operacao" />
                    </div>

                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-4">
                        <az-input 
                            placeholder="Selecione o paciente..."
                            icon="fas fa-user"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="paciente" 
                            :optimized_ac="true" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fa-solid fa-location-dot fa-fw"
                            placeholder="Status da Amostra..."
                            type="select"
                            optionsMode="aql"
                            optionsName="amostra-rastro-status-lista-peca"
                            service="amostra_rastro_status.index"
                            optionsData="id_amostra_rastro_status"
                            :optionsParm="{ ativos: true }"
                            v-model="filtros.id_amostra_rastro_status" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input 
                            icon="fa fa-play fa-fw"
                            type="select" 
                            placeholder="Status do Exame..."
                            service="status_laudos.index" 
                            optionsMode="aql" 
                            optionsData="id_status_laudo"
                            v-model="filtros.id_status_laudo" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input 
                            type="checkbox-group"
                            label="Ocultar Enviadas"
                            :edicao="filtros.status != 'P' && filtros.status != 'N'"
                            v-model="filtros.block_enviadas" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input 
                            type="checkbox-group"
                            label="Ocultar Canceladas"
                            v-model="filtros.block_canceladas" />
                    </div>
                </div>

                <div class="form-row mt-2">

                    <div class="col col-12" :class="laudos ? 'col-md-4' : 'col-md-6'">
                        <az-input  
                            icon="fas fa-search fa-fw"
                            placeholder="Pesquisar..."
                            v-model="search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="lista_exibicao.length">
                                    <span class="input-group-text" id="basic-addon2">
                                        {{ lista_exibicao.length }}
                                    </span>
                                </div>

                                <print-export printid="lista-pacientes" :dados="dados_exportacao" />
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input 
                            type="checkbox-group"
                            label="Meus"
                            v-model="filtros.meus" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            icon="fa-solid fa-barcode"
                            placeholder="Tipo de Etiqueta..."
                            optionsMode="aql"
                            optionsName="tipo-etiqueta-amostras-lista-peca"
                            service="tipo_etiqueta_amostras.index"
                            optionsData="id_tipo_etiqueta_amostra"
                            :optionsParm="{ ativos: true, filtro_geral: true }"
                            v-model="filtros.id_tipo_etiqueta_amostra" />
                    </div>

                    <div class="col col-12 col-md-4">
                        <az-input   
                            type="button-group"
                            placeholder="Todas..."
                            :optionsList="[
                                { id: '', search: 'Todas' }, 
                                { id: 'P', search: 'Pendentes' }, 
                                { id: 'R', search: 'Recebidas' }, 
                                { id: 'N', search: 'Recoletas' }, 
                            ]"
                            optionsData="id"
                            v-model="filtros.status"
                            @click="rebuscar()" />
                    </div>
                </div>

            </div>

        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>    

        <div class="text-right mb-3" v-if="laudos">
            <button type="button" class="btn btn-outline-primary btn-sm ml-1" data-toggle="tooltip" data-placement="top" title="Leitura de Amostras" @click="leitura_de_amostras_ap()">
                <i class="fa-solid fa-barcode fa-fw"></i>
            </button>
        </div>

        <!-- Fim Header -->

        <az-empty-state 
            :icon="primeiraBusca ? 'fa-solid fa-rotate' : 'fa-solid fa-vial'" 
            :msg="primeiraBusca ? 'Buscar' : 'Nenhuma amostra identificada.'" 
            v-if="!lista_exibicao.length"
            :action="primeiraBusca ? 'Buscar' : ''"
            :method="load" />

        <div id="lista-pacientes">

            <cabecalho-generico titulo="Amostras">
            </cabecalho-generico>

            <div class="card carde mb-2 w3-animate-opacity" v-for="(item, index) in lista_exibicao" :key="index">
                <div class="card-body py-1 px-2" :class="item.color ? 'alert-' + item.color : ''">
                    <div class="row">
                        <div class="col col-12 col-md-2">
                            <a href="#" class="card-link" @click.prevent="abrir_atendimento(item)">
                                #{{ item.id_atendimento }}
                            </a>
                            <span class="small text-muted ml-2" v-if="item.atendimento.marcacao.st_id_externo">
                                {{ item.atendimento.marcacao.st_id_externo }}
                            </span>
                            <span class="badge badge-light ml-2" v-if="item.atendimento.marcacao.unidade_operacao && item.atendimento.marcacao.unidade_operacao.st_sigla">
                                {{ item.atendimento.marcacao.unidade_operacao.st_sigla }}
                            </span>
                            <div v-if="item.atendimento" class="small"> 
                                {{ $util.getFormatDate(item.atendimento.dt_inicio) }}
                                {{ item.atendimento.dt_inicio.slice(11,16) }}
                            </div>
                        </div>
                        <div class="col col-12 col-md-4">
                            <div v-if="item.atendimento.marcacao.paciente">
                                <celula-dados-paciente :hor="{ marcacao: item.atendimento.marcacao }" />
                            </div>
                        </div>
                        <div class="col col-12 col-md-5">
                            <div>
                                <a href="#" class="card-link" @click.prevent="editar(item)">
                                    {{ item.st_codigo }}
                                </a>
                                <span v-if="item.st_titulo">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    {{ item.st_titulo }}
                                </span>
                                <span v-if="item.material">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    {{ item.material.st_amostra_material }}
                                </span>
                                <span v-if="item.st_destino">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    {{ item.st_destino }}
                                </span>
                            </div>
                            <div>
                                <span class="badge badge-warning mr-1" title="Exames Pendentes" v-if="item.exames_pendentes_count">
                                    {{ item.exames_pendentes_count }}
                                </span>

                                <span class="badge badge-secondary" title="Exames">
                                    {{ item.exames_count }}
                                </span>

                                <span class="small ml-3" v-if="item.last_rastro" :class="'badge badge-' + item.last_rastro.status_rastro.st_color">
                                    {{ item.last_rastro.status_rastro.search }}
                                </span>

                                <span class="small ml-3" v-else-if="item.rastro">
                                    {{ item.rastro.status_rastro.search }}
                                </span>

                                <span v-if="item.dt_prazo" class="ml-3" title="Prazo de Descarte">
                                    <i class="fa-solid fa-trash-arrow-up ml-1"></i>
                                    {{ $util.getFormatDate(item.dt_prazo) }}
                                </span>
                            </div>
                        </div>
                        <div class="col col-12 col-md-1">
                            <template v-if="item.exames && item.exames.length">
                                <span class="badge badge-primary mr-1" v-for="(exame, iex) in item.exames" :key="iex">
                                    {{ exame.atendimento_procedimento.procedimento.st_sigla ? exame.atendimento_procedimento.procedimento.st_sigla : exame.atendimento_procedimento.procedimento.st_procedimento }}
                                </span>
                            </template>
                        </div>
                    </div>
                </div>
                
                <div class="card-footer small py-1 px-2" v-if="resumo(item)">
                    <div class="text-nowrap text-truncate">
                        <a href="#" @click.prevent="item.last_rastro.fl_ativo = !item.last_rastro.fl_ativo">
                            <i class="fa-solid fa-clipboard-check mr-2"></i>
                        </a>
                        <span class="text-muted">
                            {{ resumo(item) }}
                        </span>
                    </div>
                    <div class="mt-2" v-if="item.last_rastro && item.last_rastro.js_formulario && !item.last_rastro.fl_ativo">
                        <formulario :value="item.last_rastro.js_formulario" mode="view" />
                    </div>
                </div>
            </div>

        </div>

        <br><br><br><br><br>

        <!-- Paginação -->
        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.last_page > 1">
            <div class="d-flex">
                <paginate
                    class="mb-0"
                    :page-count="dados.last_page"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :prev-text="'<<'"
                    :next-text="'>>'"
                    :click-handler="paginar">
                </paginate>
            </div>
        </nav>

        <pre class="mt-3" v-if="false">{{ lista_exibicao }}</pre>

        <amostras ref="amostras" @refresh="load" />

        <!-- Amostras de Anatomia Patológica -->
        <ler-amostras-a-p 
            ref="amoap" 
            :id_tipo_etiqueta_amostra="filtros.id_tipo_etiqueta_amostra"
            :only_amostras="true" />

    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';
import Amostras from './Amostras.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import LerAmostrasAP from '../laudos/LerAmostrasAP.vue';
import Formulario from '../consultorio/Formulario.vue';

export default {
    data() { 
        return { 
            filtros: {
                periodo: "h", 
                id_unidade_operacao: "", 
                status: "R", 
                block_enviadas: true,
                block_canceladas: true,  
                tipo_data: "dt_coleta", 
                id_amostra_rastro_status: "", 
                id_tipo_etiqueta_amostra: "", 
                id_status_laudo: "", 
                meus: false, 
            },
            paciente: "", 
            search: "", 
            dados: null, 
            page: 1, 
            primeiraBusca: true, 
        }
    },

    components: {
        AzInput,
        AzPeriodo, 
        AzEmptyState, 
        CelulaDadosPaciente, 
        Amostras, 
        PrintExport,
        CabecalhoGenerico, 
        LerAmostrasAP, 
        Formulario, 
    },

    props: ['laudos'], 

    computed: { 
        lista_exibicao: function () { 
            if ( !this.dados || !this.dados.data || !this.dados.data.length )
                return [];

            let reg = this.$util.getregex(this.search);

            return this.dados.data.filter(item => !this.search || reg.test(JSON.stringify(item)));
        },

        dados_exportacao: function () { 

            return this.lista_exibicao.map(item => { 
                return { 
                    "Atendimento": item.id_atendimento, 
                    "OS": item.atendimento.marcacao.st_id_externo,
                    "Paciente": item.atendimento.marcacao.paciente.st_nome, 
                    "Unidade": item.atendimento.marcacao.unidade_operacao ? item.atendimento.marcacao.unidade_operacao.st_sigla : '',
                    "OperadoraPlano": item.atendimento.marcacao.plano ? item.atendimento.marcacao.plano.search : '',
                    "CodigoAmostra": item.st_codigo,
                    "Data": this.$util.getFormatDate(item.atendimento.dt_inicio), 
                    "Hora": item.atendimento.dt_inicio.slice(11,16), 
                    "Exames": item.exames_count, 
                    "Pendentes": item.exames_pendentes_count, 
                    "Titulo": item.st_titulo, 
                    "Material": item.material ? item.material.st_amostra_material : '', 
                    "Destino": item.st_destino, 
                    "Rastreabilidade": item.rastro ? item.rastro.status_rastro.search : '', 
                }
            });

        }
    },

    methods: { 
        resumo (amostra) { 
            if ( !amostra || !amostra.last_rastro || !amostra.last_rastro.js_formulario || !amostra.last_rastro.js_formulario.length )
                return '';

            return amostra.last_rastro.js_formulario.filter(campo => campo.value)
                .map(campo => {
                    return `${campo.label}: ${campo.value}`;
                })
                .join(' | ');
        },

        leitura_de_amostras_ap () { 
            this.$refs.amoap.abrir(); 
        },

        rebuscar () { 
            this.$nextTick(() => { 
                this.page = 1; 
                this.load();
            });
        },

        paginar (page) {
            this.page = page;
            this.load();
        },

        abrir_atendimento (item) { 
            this.$util.abrir_atendimento(this, item.id_atendimento);    
        },

        load(page = null) { 
            this.primeiraBusca = false; 

            if ( page ) { 
                this.page = page;
            }

            this.$util.load(this, { 
                service: 'amostras',
                func: 'posicao', 
                page: this.page,
                parms: { 
                    ...this.filtros,
                    id_paciente: this.paciente ? this.paciente.id_pessoa : null, 
                    search: this.search, 
                    page: this.page,
                    anat_pat: this.laudos ? true : false,
                }, 
                loadTo: res => { 
                    this.dados = res.lista;
                }
            });
        },

        editar (item) { 
            this.$refs.amostras.abrir(item.id_atendimento, false, item.st_codigo);
        }
    },
    beforeMount() { 
        if ( this.laudos ) { 
            this.filtros.block_enviadas = false; 
        }
    },  

    mounted() { 
        if ( !this.laudos ) { 
            this.$store.commit("setBreadcrumb", [
                { name: 'Laboratório', path: "/laboratorio/visao" },
                { name: "Amostras", path: "/laboratorio/amostras" }
            ]);
        }

        const uo = this.$util.unidade_operacao();

        if ( uo ) { 
            this.filtros.id_unidade_operacao = uo.id_unidade_operacao;
        }
    }
}
</script>
